import { useState } from "react";
import { Link } from "react-router";
import { HeaderItem } from "../../types/menu.type";
import Badge from "../badge";
import { useTranslation } from "react-i18next";

const MobileHeaderLink: React.FC<{
  item: HeaderItem;
  isOpen: boolean;
  onToggle: () => void;
  closeNavbar: () => void;
}> = ({ item, isOpen, onToggle, closeNavbar }) => {
  const [openSubIndex, setOpenSubIndex] = useState<number | null>(null);

  const { t } = useTranslation("menu");
  

  return (
    <div className="relative w-full">
      {/* Main Row */}
      <div
        onClick={item.submenu ? onToggle : closeNavbar}
        className="flex items-center justify-between w-full py-3 px-2 text-dark dark:text-white hover:bg-gray-100 dark:hover:bg-dark_grey rounded-lg cursor-pointer"
      >
        <div className="flex items-center gap-2">
          {item.badge && <Badge mobile={true} />}
          <Link to={t(item.href)}><span>{t(item.label)}</span></Link>
        </div>

        {item.submenu && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1.5em"
            height="1.5em"
            viewBox="0 0 24 24"
            className={`transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="m7 10l5 5l5-5"
            />
          </svg>
        )}
      </div>

      {/* Submenu */}
      {isOpen && item.submenu && (
        <div className="ml-4 mt-1 flex flex-col rounded-lg bg-gray-50 dark:bg-dark_grey overflow-hidden">
          {item.submenu.map((group, groupIndex) => (
            <div key={groupIndex} className="py-2">
              {group.title && (
                <span className="block px-4 pb-1 text-xs font-semibold uppercase text-gray-400">
                  {t(group.title)}
                </span>
              )}

              {group.items.map((subItem, index) => {
                const hasNested = subItem.subItems && subItem.subItems.length > 0;
                const isNestedOpen = openSubIndex === index;

                return (
                  <div key={index} className="w-full">
                    <div
                      onClick={
                        hasNested
                          ? () =>
                              setOpenSubIndex(isNestedOpen ? null : index)
                          : closeNavbar
                      }
                      className="flex items-center justify-between py-2 px-6 text-dark dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-md cursor-pointer"
                    >
                      <span><Link to={subItem.href}>{t(subItem.label)}</Link></span>
                      {hasNested && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="1.2em"
                          height="1.2em"
                          viewBox="0 0 24 24"
                          className={`transition-transform duration-300 ${
                            isNestedOpen ? "rotate-180" : ""
                          }`}
                        >
                          <path
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.5"
                            d="m7 10l5 5l5-5"
                          />
                        </svg>
                      )}
                    </div>

                    {/* Nested Dropdown */}
                    {hasNested && isNestedOpen && (
                      <div className="ml-6 mt-1 flex flex-col rounded-lg bg-gray-100 dark:bg-gray-800">
                        {subItem.subItems!.map((child, childIndex) => (
                          <Link
                            key={childIndex}
                            to={child.href}
                            // onClick={closeNavbar}
                            className="block py-2 px-6 text-sm text-dark dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-md"
                          >
                            {child.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileHeaderLink;
